import { Skeleton, SkeletonCircle, SkeletonText, Stack, Td, Tr } from '@chakra-ui/react';
import * as React from 'react';

export const MemberPlaceholders: React.FC<{ length: number }> = ({
  length = 50,
}) => {
  return (
    <>
      {[...Array(length)].map((_, index) => (
        <Tr
          key={index}
          sx={{ '&:last-of-type': { td: { borderBottom: 'none' } } }}
        >
          <Td pr="0" width={10}><Skeleton width="20px" height="20px" /></Td>
          <Td pr="2" pl="2" width="full">
            <Stack direction="row" spacing="4" alignItems="center">
              <SkeletonCircle size="12" />
              <SkeletonText noOfLines={2} width="40" />
            </Stack>
          </Td>
           <Td pr="2" pl="2">
            <SkeletonText noOfLines={1} width="20" />
          </Td>
          <Td>
            <SkeletonText noOfLines={1} width="20" />
          </Td>
          <Td pr="2" pl="2">
            <SkeletonText noOfLines={1} width="20" />
          </Td>
          <Td pr="2" pl="2">
            <SkeletonText noOfLines={1} width="15" />
          </Td>
          <Td pr="2" pl="2">
            <SkeletonText noOfLines={1} width="15" />
          </Td>
          <Td pr="2" pl="2">
            <SkeletonText noOfLines={1} width="15" />
          </Td>
        </Tr>
      ))}
    </>
  );
};
